import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageMetaData } from '@sparro/app/core/models/media.model';

import { ALLOWED_HOSTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { Project } from '@sparro/app/core/models/project.model';
import { ConfirmationDialogComponent } from '@sparro/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-project-card-image',
  templateUrl: './project-card-image.component.html',
  styleUrls: ['./project-card-image.component.scss']
})
export class ProjectCardImageComponent implements OnInit {
  @Input() project: Project;
  @Input() featured: boolean = false;
  @Input() self: boolean = false;
  @Input() showTrophyBadge: boolean = false;
  @Input() showGeneralBadges: boolean = false;
  @Input() dialogOpenable: boolean = true;
  @Output() openDialogEvent = new EventEmitter();
  noImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;
  projectImageMetaData: ImageMetaData;
  @Input() host: ALLOWED_HOSTS;

  @Input() imageStyle: string; // Adding for backward compatibility with connect project + entries

  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  openDialog(): boolean {
    if (this.dialogOpenable) {
      this.openDialogEvent.emit();
    }
    return !this.dialogOpenable;
  }

  getProjectDetailLink(): string {
    if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
      // Eval compatibility
      return `${environment.evalUrl}/${this.project.chamber_id}/project/${this.project.id}`;
    } else {
      if (this.project.slug) {
        return `${environment.projectUrl}${this.project.slug}`;
      } else if (this.self) {
        return `${environment.projectUploaderUrl}project/${this.project.uuid}/edit`;
      }
    }
  }

  openPrivatePopup() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      height: 'auto',
      data: {
        message: `<p style="text-align:center; margin:0px;">
        This is a private project, you can't view it.</p>`,
        okayButtonText: 'Okay'
      }
    });
  }

}
